const BookingCTA = () => {
  return (
    <section className="bg-sage py-32 px-6">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-5xl font-bold text-white font-serif mb-6">
          Ready to Book?
        </h2>

        <p className="text-lg text-cream font-sans mb-12">
          Call us or book online for your preferred time
        </p>

        <a
          href="tel:01943123456"
          className="inline-flex items-center gap-3 px-12 py-4 bg-white text-charcoal font-sans text-lg font-semibold rounded-full hover:scale-105 transition-transform whitespace-nowrap cursor-pointer shadow-lg"
        >
          <i className="ri-calendar-line text-2xl"></i>
          Book Now
        </a>
      </div>
    </section>
  );
};

export default BookingCTA;